module.exports = __webpack_public_path__ + "img/tile_virtual_1.8f2c3f86.jpg";